import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const ControlIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 32 32">
      <path
        fill="currentColor"
        d="M6,4C3.8,4,2,5.8,2,8c0,1.9,1.3,3.4,3,3.9V27c0,0.6,0.4,1,1,1s1-0.4,1-1V11.9c1.7-0.4,3-2,3-3.9C10,5.8,8.2,4,6,4z"
        strokeWidth="1px"
        stroke="currentColor"
      />
      <path
        fill="currentColor"
        d="M17,16.1V5c0-0.6-0.4-1-1-1s-1,0.4-1,1v11.1c-1.7,0.4-3,2-3,3.9s1.3,3.4,3,3.9V27c0,0.6,0.4,1,1,1s1-0.4,1-1v-3.1
		c1.7-0.4,3-2,3-3.9S18.7,16.6,17,16.1z"
    strokeWidth="1px"
        stroke="currentColor"
      />
      <path
        fill="currentColor"
        d="M30,14c0-1.9-1.3-3.4-3-3.9V5c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.1c-1.7,0.4-3,2-3,3.9s1.3,3.4,3,3.9V27c0,0.6,0.4,1,1,1
		s1-0.4,1-1v-9.1C28.7,17.4,30,15.9,30,14z"
    strokeWidth="1px"
        stroke="currentColor"
      />
    </BaseIcon>
  );
};

export default ControlIcon;
